export default __webpack_public_path__ + "static/opengraph-6d264e6c3bfb0c4203e2cd1102df9d6c.png";